// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1wrFq","rootSuccess":"CompleteLink_rootSuccess__1eTVH","rootFailure":"CompleteLink_rootFailure__2yGN9","isDisabled":"CompleteLink_isDisabled__rI_X3"};